
import React, { useContext, useEffect, useState } from 'react'
import AdminSideBar from '../../components/adminSideBar/AdminSideBar'
import { SettingContext } from '../../context/settingContext/SettingContext';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import { getSettings, updateSettings } from '../../context/settingContext/apiCalls';
import FormInput from '../../components/formInput/FormInput';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import { communes, wilayas } from '../../data';
import "./settingDetail.css";

export default function SettingDetail() {
    const { dispatch, settings, message, isFetchingGet, errorGet, isFetchingUpdate, errorUpdate, } = useContext(SettingContext);
    const [errorSettings, setErrorSettings] = useState("");
    const [IsFetchingSettings, setIsFetchingSettings] = useState(false);

    const [fullName, setFullName] = useState("");
    const [address, setAddress] = useState("");
    const [wilaya, setWilaya] = useState("");
    const [commune, setCommune] = useState("");
    const [telephone, setTelephone] = useState("");
    const [rc, setRc] = useState("");
    const [nif, setNif] = useState("");
    const [nis, setNis] = useState("");
    const [ai, setAi] = useState("");
    const [capital, setCapital] = useState("");

    useEffect(() => {
        if (errorGet !== false) {
            setErrorSettings(errorGet);
        }
        if (errorUpdate !== false) {
            setErrorSettings(errorUpdate);
        }
    }, [errorGet, errorUpdate]);

    useEffect(() => {
        setIsFetchingSettings(isFetchingGet || isFetchingUpdate);
    }, [isFetchingGet, isFetchingUpdate]);

    useEffect(() => {
        getSettings(dispatch);
    }, [message]);

    useEffect(() => {
        if (Object.keys(settings).length !== 0) {
            setFullName(settings.fullname);
            setAddress(settings.address);
            setWilaya(wilayas.filter(item => item.id === settings.wilaya)[0]['nom']);
            setCommune(communes[settings.wilaya].filter(item => item.id === settings.commune)[0]['nom']);
            setTelephone(settings.telephone);
            setRc(settings.rc);
            setNif(settings.nif);
            setNis(settings.nis);
            setAi(settings.ai);
            setCapital(settings.capital);
        }
    }, [settings])

    const updateSettingsHandler = () => {
        if (fullName.trim() == "") {
            setErrorSettings(`Vous devez compléter le Nom`);
            return;
        }
        if (address.trim() == "") {
            setErrorSettings(`Vous devez compléter l'Adresse`);
            return;
        }
        if (telephone.trim() == "") {
            setErrorSettings(`Vous devez compléter le Téléphone`);
            return;
        }
        if (rc.trim() == "") {
            setErrorSettings(`Vous devez compléter le le numero de registre commerce`);
            return;
        }
        if (nif.trim() == "") {
            setErrorSettings(`Vous devez compléter le numero d'identification fiscale`);
            return;
        }
        if (nis.trim() == "") {
            setErrorSettings(`Vous devez compléter le numero d'identification statistique`);
            return;
        }
        if (ai.trim() == "") {
            setErrorSettings(`Vous devez compléter l'article d'imposition`);
            return;
        }
        if (capital.trim() == "") {
            setErrorSettings(`Vous devez compléter le Capital`);
            return;
        }
        setErrorSettings('');
        updateSettings(dispatch,fullName, address, telephone, rc, nif, nis, ai, capital);
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="setting" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Paramètres :</span>
                </div>

                {
                    (errorGet || errorUpdate) ? <ErrorComponent error={errorSettings} /> : (
                        IsFetchingSettings ? <LoadingComponent /> : (
                            <div className="content invoice settings">
                                <div className="box">
                                    <div className="box-title" style={{ marginBottom: "25px", }}>Paramètres Généraux</div>
                                    {errorSettings !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorSettings}</div>)}
                                    <div className="box-content">
                                        <FormInput label="Nom Complet" itemInput={fullName} setItemInput={setFullName} auth />
                                        <FormInput label="Address" itemInput={address} setItemInput={setAddress} auth />
                                        <FormInput label="Wilaya" itemInput={wilaya} setItemInput={setWilaya} auth inactive />
                                        <FormInput label="Commune" itemInput={commune} setItemInput={setCommune} auth inactive />
                                        <FormInput label="Télephone" itemInput={telephone} setItemInput={setTelephone} auth />
                                        <FormInput label="RC" itemInput={rc} setItemInput={setRc} auth />
                                        <FormInput label="NIF" itemInput={nif} setItemInput={setNif} auth />
                                        <FormInput label="NIS" itemInput={nis} setItemInput={setNis} auth />
                                        <FormInput label="AI" itemInput={ai} setItemInput={setAi} auth />
                                        <FormInput label="Capital" itemInput={capital} setItemInput={setCapital} auth istype='number' />
                                        <div className='button' onClick={updateSettingsHandler} style={isFetchingUpdate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                            <span>
                                                {isFetchingUpdate ? "Modifier ..." : "Modifier"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    )
                }
            </div>
        </div>
    )
}
